import React from 'react';
import { Select } from 'antd';
import { renderEccnOption } from './estimateFormHandlers';

const EstimateFormOptions = ({ formData, setFormData, errors, setErrors, isReadOnly, handleInputChange, onInsuranceChange, eccnCodes }) => {
    return (
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-6 mt-6 mb-6">
            {formData.selectedService !== "EOR" && (
                <div className="flex flex-col md:w-1/2">
                    <label className="blockbit mb-2 text-md font-normal">
                        Import documentation required? <span className="text-red-500">*</span>
                    </label>
                    <div className={`flex gap-4 ${errors.requiredDoc ? "p-2 border border-red-500 rounded-sm" : ""}`}>
                        <label className="flex items-center">
                            <input
                                type="radio"
                                name="requiredDoc"
                                value="Required"
                                onChange={e => handleInputChange(e, setFormData, setErrors)}
                                checked={formData.requiredDoc === "Required"}
                                disabled={isReadOnly}
                                className="form-radio h-4 w-4 text-cus-blue"
                            />
                            <span className="ml-2">Required</span>
                        </label>
                        <label className="flex items-center">
                            <input
                                type="radio"
                                name="requiredDoc"
                                value="not_Required"
                                onChange={e => handleInputChange(e, setFormData, setErrors)}
                                checked={formData.requiredDoc === "not_Required"}
                                disabled={isReadOnly}
                                className="form-radio h-4 w-4 text-cus-blue"
                            />
                            <span className="ml-2">Not Required</span>
                        </label>
                    </div>
                    {errors.requiredDoc && (
                        <p className="text-red-500 text-xs mt-1">Documentation requirement is required</p>
                    )}
                </div>
            )}
            {(formData.selectedService === "EOR" || formData.selectedService === "EOR & IOR") && (
                <div className="flex flex-col md:w-1/2">
                    <label className="block mb-2 text-md font-normal">
                        ECCN Code <span className="text-red-500">*</span>
                    </label>
                    <Select
                        showSearch
                        placeholder="Select ECCN Code"
                        value={formData.eccnCode}
                        onChange={value => setFormData(prev => ({ ...prev, eccnCode: value }))}
                        className={`w-full ${errors.eccnCode ? "border-red-500" : ""}`}
                        style={{ width: "100%" }}
                        optionLabelProp="label"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.props.children.some(child =>
                                child.toString().toLowerCase().includes(input.toLowerCase())
                            )
                        }
                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                        disabled={isReadOnly}
                    >
                        {eccnCodes.map(eccn => (
                            <Select.Option
                                key={eccn.eccn_code}
                                value={eccn.eccn_code}
                                label={eccn.eccn_code}
                            >
                                {renderEccnOption(eccn)}
                            </Select.Option>
                        ))}
                    </Select>
                    {errors.eccnCode && (
                        <p className="text-red-500 text-xs mt-1">ECCN Code is required for EOR service</p>
                    )}
                </div>
            )}
            <div className="flex flex-col md:w-1/2">
                <label className="block mb-2 text-md font-normal">
                    Do you need insurance? <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center">
                    <label className="inline-flex items-center mr-4">
                        <input
                            type="radio"
                            className="form-radio h-4 w-4 text-cus-blue"
                            name="insuranceSelected"
                            value="YES"
                            checked={formData.insuranceSelected === "YES"}
                            onChange={() => onInsuranceChange("YES")}
                            disabled={isReadOnly}
                        />
                        <span className="ml-2">Yes</span>
                    </label>
                    <label className="inline-flex items-center">
                        <input
                            type="radio"
                            className="form-radio h-4 w-4 text-cus-blue"
                            name="insuranceSelected"
                            value="NO"
                            checked={formData.insuranceSelected === "NO"}
                            onChange={() => onInsuranceChange("NO")}
                            disabled={isReadOnly}
                        />
                        <span className="ml-2">No</span>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default EstimateFormOptions;